/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mySwiper.vue?vue&type=template&id=553575cb&scoped=true"
import script from "./mySwiper.vue?vue&type=script&lang=js"
export * from "./mySwiper.vue?vue&type=script&lang=js"
import style0 from "./mySwiper.vue?vue&type=style&index=0&id=553575cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553575cb",
  null
  
)

export default component.exports